// extracted by mini-css-extract-plugin
export var closeButton = "_lh-2";
export var closeButtonIcon = "_lh-3";
export var lightboxContent = "_lh-1";
export var lightboxOverlay = "_lh-0";